<div class="container">
  <div class="my-3 mb-4">
    <h3>Select Items to Return</h3>
  </div>

  <form [formGroup]="returnForm">
    <div class="mb-3">
      <label for="return_reason" class="form-label">Return Reason</label>
      <textarea
        id="return_reason"
        class="form-control"
        formControlName="return_reason"
        rows="3"
        placeholder="Please provide a reason for the return"
      ></textarea>
    </div>
  </form>

  <ng-container *ngIf="returnItems.length > 0">
    <div class="card border rounded-2 position-relative mb-3" *ngFor="let item of returnItems">
      <div class="p-2">
        <div class="d-flex align-items-center">
          <img [src]="item.image" [alt]="item.inventory" class="rounded" style="width: 60px; height: 60px; object-fit: cover;">
          <div class="d-block ms-2">
            <h6 class="mb-0 text-break me-2">{{ item.inventory }}</h6>
            <p class="mb-0">₦{{ item.amount }}</p>
          </div>
          <div class="ms-auto border rounded-2 me-2">
            <div class="quantity-control d-flex justify-content-between align-items-center me-1">
              <button
                class="btn btn-lg btn-clear"
                (click)="decreaseQuantity(item)"
                [disabled]="item.quantity === 0">−</button>
              <span class="quantity ms-2 me-2">{{ item.quantity }}</span>
              <button class="btn btn-lg btn-clear" disabled>+</button>
            </div>
          </div>
        </div>
        <div class="mt-2" *ngIf="item.quantity < item.originalQuantity">
          <small class="text-danger">
            Returning: {{ item.originalQuantity - item.quantity }} items
          </small>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="mt-4 mb-3">
    <button
      class="btn btn-primary btn-block w-100"
      (click)="confirm()"
      [disabled]="!canSubmit()">
      Continue
    </button>
  </div>
</div>
